import { render, staticRenderFns } from "./PromotionsList.vue?vue&type=template&id=1abf8e5e&"
import script from "./PromotionsList.vue?vue&type=script&lang=ts&"
export * from "./PromotionsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports